var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 126,
    viewBox: "0 0 125 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 125,
    height: 125,
    rx: 62.5,
    fill: "#33D67C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.584 69.896V63.048H47.616V51.976H54.592V63.048H66.56V69.896H54.592V80.968H47.616V69.896H35.584ZM79.4035 85V49.544L72.0435 51.272V45L82.8595 40.2H87.9155V85H79.4035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Icon);
export default __webpack_public_path__ + "static/media/+1icon.d5869a8c255b8baf3495875435858e0c.svg";
export { ForwardRef as ReactComponent };